export function toggleReturnsCenterId(
  ids: readonly string[] | undefined,
  id: string,
): string[] {
  const current = ids ?? [];
  if (current.includes(id)) {
    return current.filter((x) => x !== id);
  }
  return [...current, id];
}

export function bulkToggleReturnsCenterIds(
  ids: readonly string[] | undefined,
  centerIds: string[],
  select: boolean,
): string[] {
  const current = new Set(ids ?? []);
  if (select) {
    for (const id of centerIds) {
      current.add(id);
    }
  } else {
    for (const id of centerIds) {
      current.delete(id);
    }
  }
  return Array.from(current);
}
